import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Project: A funded research initiative funded under an award, with specific objectives, personnel, and financial oversight that occurs over a period of time.',
    name: 'Projects',
    partialId: PartialId.Standard.create('projects'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
